import React from 'react'

const Footer = () => {
  const randomFacts = [
    "I once tried to push to production on a Friday. I don't make that mistake anymore... (lies, I did it last week)",
    "My code has been described as 'abstract art' by senior developers (not a compliment)",
    "I have 47 unfinished side projects and counting. This website is #48 (and actually finished!)",
    "I speak fluent JavaScript but my accent is terrible - full of undefined behavior",
    "My git commit messages are either novels or just '.' - there's no middle ground"
  ]

  const randomFact = randomFacts[Math.floor(Math.random() * randomFacts.length)]

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>🎪 Welcome to the Circus!</h4>
          <p>Step right up and witness the amazing spectacle of functional code held together by sheer willpower and an unhealthy amount of console.log statements!</p>
          <p>🎭 <strong>Today's Random Developer Confession:</strong> {randomFact}</p>
        </div>

        <div className="footer-section">
          <h4>🎯 Bug Report Status</h4>
          <div style={{ fontFamily: 'monospace', background: '#000', color: '#0f0', padding: '10px', borderRadius: '5px' }}>
            <div>🐛 Bugs squashed today: 3</div>
            <div>🦟 New bugs created: 7</div>
            <div>🔥 Code on fire: Always</div>
            <div>☕ Coffee level: CRITICAL</div>
            <div>🧠 Brain.exe: Not responding</div>
          </div>
        </div>

        <div className="footer-section">
          <h4>🎮 Developer Stats</h4>
          <p>
            💪 <strong>Strength:</strong> Googling errors<br />
            🧙‍♂️ <strong>Magic:</strong> Making things work accidentally<br />
            🎲 <strong>Luck:</strong> Sometimes my code works<br />
            🤡 <strong>Humor:</strong> Laughing at my own bugs<br />
            🔮 <strong>Wisdom:</strong> Knowing when to restart the computer
          </p>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} El-Habib Amazzal | Senior Software Engineer & Chief Chaos Creator 🌪️</p>
          <small>
            Powered by <span className="heart">❤️</span>, Stack Overflow wizardry 🧙‍♂️, Cursor AI magic ✨, vibe-based coding 🎵, and pure chaos energy ⚡
          </small>
          <small>
            🎪 "Welcome to my TED Talk: Why my code works but I don't know why" - Coming soon to a bug report near you
          </small>
          <small style={{ marginTop: '10px', display: 'block' }}>
            🎉 Fun fact: This footer changes every time you refresh! (Just kidding, but wouldn't that be cool?)
          </small>
        </div>
      </div>
    </footer>
  )
}

export default Footer